module.exports = __webpack_public_path__ + "static/Q3_2025_Announcement_Financial_Results-e9da7f140e24027d4fb53ec5b8e5f753.pdf";